import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alignItems"},[_c('span',[_vm._v(_vm._s(_vm.$t("MyWorkspaces.filterLabels.lastModified")))]),_c(VSelect,{attrs:{"items":_vm.dateOptions,"menu-props":{ offsetY: true },"hide-details":""},model:{value:(_vm.lastModified),callback:function ($$v) {_vm.lastModified=$$v},expression:"lastModified"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }